import React from 'react';

import { getFriendsList } from 'api/friendsAPICall';
import ApplicationEvents from 'components/applicationEvents';
import { ViewAppIdIcon } from 'components/commonAssets';
import { _I_ } from 'components/translate';
import { LogStream } from 'generics/common';
import { loadCurrentApp } from 'generics/routed.js';
import { classMixer } from 'generics/utils';

LogStream.enable("VIEWUSERFRIENDSLIST");

export class ViewUserFriendsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      "friends": [],
      "cropped": true,
      "maxCount": 10
    }
  }

  componentDidMount() {
    this.loadFriendsList();
  }

  loadFriendsList() {
    const { appIds } = this.props;

    getFriendsList(appIds).then((friends) => {
      console.log('loadFriendsList -> ', friends);
      this.setState({ friends });
    }).catch(error => {
      console.log('loadFriendsList failed -> ', error);
    });
  }

  onChangeUID(uID, nick, appId) {
    ApplicationEvents.emit_async("achievement.setCurrentUserById", uID, nick);
    ApplicationEvents.emit_async("achievement.setCurrentAppId", appId);
  }

  renderFriendsList() {
    const { appIds } = this.props;
    const { friends, cropped, maxCount } = this.state;
    const lruAppId = +(loadCurrentApp());
    const currentAppId = (appIds.length == 1) ? appIds[0] : lruAppId;
    const filteredItems = friends.filter(item => item.appId == currentAppId);
    const items = cropped ? filteredItems.slice(0, maxCount) : filteredItems;

    return (
      <div className="itemList">
        {items.map(({ appId, uid, nick }) => (
          <ViewUserFriend
            key={`f_${appId}_${uid}`}
            userId={uid}
            nick={nick}
            appId={appId}
            handler={() => this.onChangeUID(uid, nick, appId)}
          />
        ))}
      </div>
    )
  }

  showMore() {
    this.setState({ "cropped": false });
  }

  render() {
    const totalFriends = this.state.friends.length;
    const showMoreButton = totalFriends > this.state.maxCount && this.state.cropped;
    const showMoreClass = classMixer("view-friends-list-more", showMoreButton ? '' : 'hidden');
    const friendsListClass = classMixer("view-friends-list", !!totalFriends ? '' : 'hidden');

    return (
      <div className={friendsListClass}>
        <div className="right-menu-label">{_I_("UserFriendsList.heading.myFriends")}</div>
        {this.renderFriendsList()}
        <div className={showMoreClass} onClick={() => this.showMore()}><b>{_I_("UserFriendsList.heading.showMore")}</b></div>
      </div>
    );
  }
}

class ViewUserFriend extends React.Component {
  render() {
    const { appId, nick, handler } = this.props;

    return (
      <div onClick={handler}>
        <ViewAppIdIcon mini appId={appId} children={<b>{nick}</b>} />
      </div>
    )
  }
}